<div class="main-container">
  <h2 class="page-header">Settings - User Management</h2>
  <!-- Header with Filter Controls -->
  <div class="toolbar">
    <div class="toolbar-left">
      <div class="filter-controls-container">
        <!-- Choose filtered field -->
        <div ngbDropdown #filterDropdown="ngbDropdown" class="filter-field-selector">
          <button id="dropdownMenu" ngbDropdownToggle class="filter-input-container" (click)="onFilterDropdownClick(filterDropdown, $event)">
            <span>Filter by {{ filterField }}</span>
            <span class="chev"><app-chevron-down-icon color="var(--orange-400)" width="24" height="24"></app-chevron-down-icon></span>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownMenu" class="dropdown-menu-panel scrollable-list">
            <ng-container *ngFor="let filterKey of visibleFilterFieldOptions">
              <button ngbDropdownItem (click)="putFilterField(filterKey)" class="dropdown-item">
                {{ filterKey }}
              </button>
            </ng-container>
          </div>
        </div>
        
        <!-- Choose filtered value -->
        <div class="filter-value-area">
          <!-- Dropdown Picker -->
          <ng-container *ngIf="currentFilterType === FilterType.DROPDOWN">
            <div ngbDropdown #filterDropdown="ngbDropdown" class="filter-input-container" autoClose="outside" 
                (openChange)="$event && onFilterValueDropdownOpen()">
              <button ngbDropdownToggle class="date-range-trigger">
                <span>Select Value</span>
                <span class="chev">
                  <app-chevron-down-icon color="var(--grey-500)"></app-chevron-down-icon>
                </span>
              </button>
              <div ngbDropdownMenu class="dropdown-menu-panel">
                <div class="dropdown-search">
                  <input type="text" placeholder="Search" [(ngModel)]="searchTextInDropdownMenu" (input)="searchInDropdownMenu()"
                    aria-label="Search columns" />
                  <span aria-hidden="true">
                    <i class="pe-7s-search" style="color: var(--orange-400); font-size: 16px;"></i>
                  </span>
                </div>

                <div class="dropdown-actions">
                  <button type="button" (click)="selectAllMenuItems()">Select All</button>
                  <button type="button" (click)="deselectAllMenuItems()">Deselect All</button>
                  <button type="button" (click)="toggleShowSelectedMenuItem()">{{ showSelectedMenuItem ? 'Show All' : 'Show Selected' }}</button>
                </div>
            
                <div class="divider"></div>
            
                <div class="recursive-menu-scrollable-list">
                  <ng-container *ngFor="let option of currentDropdownOptions">
                    <ng-container *ngTemplateOutlet="dropdownItemTemplate; context: { $implicit: option, level: 0 }"></ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Text Input -->
          <ng-container *ngIf="currentFilterType === FilterType.TEXT_INPUT">
            <div class="filter-input-container">
              <input 
                type="text" 
                [(ngModel)]="textInputFilter" 
                placeholder="Enter Value"
                [attr.aria-label]="'Enter Value of ' + filterField"
                (input)="applyCurrentFilter()">
              <span aria-hidden="true">
                <i class="pe-7s-search" style="color: var(--grey-500); font-size: 16px;"></i>
              </span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="toolbar-right">
      <!-- Customize -->
      <div class="customize-dropdown">
        <button type="button" class="customize-trigger" [class.open]="showCustomize"
          (click)="toggleCustomizeDropdown()" [attr.aria-expanded]="showCustomize" aria-haspopup="true"
          aria-label="Customize columns">
          <span>Customize</span>
          <span class="chev">
            <app-chevron-down-icon width="24" height="24" color="var(--orange-400)"></app-chevron-down-icon>
          </span>
        </button>

        <div class="customize-panel" *ngIf="showCustomize" [attr.tabindex]="0" aria-label="Customize columns">
          <div class="dropdown-search">
            <input type="text" placeholder="Search" [(ngModel)]="customizeSearch" aria-label="Search columns" />
            <span aria-hidden="true">
              <i class="pe-7s-search" style="color: var(--orange-400); font-size: 16px;"></i>
            </span>
          </div>

          <div class="dropdown-actions">
            <button type="button" (click)="selectAllColumns()">Select All</button>
            <button type="button" (click)="deselectAllColumns()">Deselect All</button>
            <button type="button" (click)="toggleShowSelectedFieldsOnly()">{{ showSelectedFieldsOnly ? 'Show All' : 'Show Selected' }}</button>
          </div>

          <div class="divider"></div>

          <div class="scrollable-list">
            <div class="dropdown-item" *ngFor="let col of filteredColumns; let i = index">
              <span class="drag-handle" aria-hidden="true"><span></span><span></span><span></span></span>
              <input type="checkbox" [id]="'col-' + ($any(col).colId || i)" [checked]="!col.hide"
                (change)="onToggleColumnById($any(col).colId, $any($event.target).checked)" />
              <label [for]="'col-' + ($any(col).colId || i)">{{ col.headerName || col.field || ('Column ' + (i + 1)) }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Filter Badges -->
  <div class="badge-row" *ngIf="getFiltersArray().length > 0">
    <div class="badges">
      <ng-container *ngFor="let filter of getFiltersArray(); trackBy: trackByFilter" >
        <span class="badge badge-orange">
          <span class="badge-text">{{ getFilterDisplayText(filter[0], filter[1]) }}</span>
          <button class="badge-x" (click)="removeFilter(filter[0]); $event.stopPropagation(); $event.preventDefault()" aria-label="Remove filter badge">✕</button>
        </span>
      </ng-container>
      <div class="badge-meta" *ngIf="filters.size > 0">
        <span>Filtered {{ totalItems }} out of {{ totalItemsWithoutFilters }}</span>
        <button class="link" (click)="clearAllFilters()">Clear All Filters</button>
      </div>
    </div>
  </div>

  <!-- User Management table -->
  <div class="card">
    <div class="ag-grid-container">
      <div class="ag-theme-alpine">
        <ag-grid-angular style="width: 100%; height: 100%;"
          [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [rowData]="userData" [pagination]="true"
          [paginationPageSize]="rowsPerPage" [suppressPaginationPanel]="true" [suppressRowClickSelection]="true"
          [rowSelection]="'multiple'" [theme]="'legacy'" [getRowId]="getRowId" (gridReady)="onGridReady($event)"
          [enableCellTextSelection]="true" [suppressDragLeaveHidesColumns]="true" [suppressMovableColumns]="false"
          [overlayNoRowsTemplate]="noRowsTemplate"> 
        </ag-grid-angular>
        
        <!-- Actions dropdown menu positioned absolutely -->
        <div class="actions-menu-container" *ngIf="openedActionRowId !== null && selectedRow">
          <div class="actions-menu" [style.top.px]="actionMenuPosition.top" [style.left.px]="actionMenuPosition.left">
            <button class="action-item" *ngIf="shouldShowApproveAction(selectedRow)" (click)="onApproveAction()">Approve</button>
            <button class="action-item" *ngIf="shouldShowRejectAction(selectedRow)" (click)="onRejectAction()">Reject</button>
          </div>
        </div>
      </div>
    </div>
    <!-- NgBootstrap pagination as card footer -->
    <div class="pager">
      <div class="pager-left">
        Showing <span class="high-light">{{ getItemRangeInPage() }}</span> out of <span class="high-light">{{ totalItems }}</span>
      </div>

      <div class="pager-center">
        <ngb-pagination [(page)]="currentPage" [pageSize]="rowsPerPage" [collectionSize]="totalItems" [maxSize]="5"
          [rotate]="false" [boundaryLinks]="true" [directionLinks]="true" [ellipses]="false"
          (pageChange)="onPageChange($event)">
        </ngb-pagination>
      </div>

      <div class="pager-right">
        <span class="muted">Show rows</span>
        <select [ngModel]="rowsPerPage" (ngModelChange)="changeRowsPerPage($event)" name="rowsPerPage">
          <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{size}}</option>
        </select>
      </div>
    </div>
  </div>
</div>

<!-- Recursive template for nested dropdown items -->
<ng-template #dropdownItemTemplate let-option let-level="level">
  <div class="dropdown-item" *ngIf="option.visible" [style.padding-left.px]="level > 0 ? 30 : 8">
    <div class="dropdown-item-content">
      <div class="checkbox-label-container">
        <input 
          type="checkbox" 
          [id]="'checkbox-' + option.value + '-level-' + level" 
          [checked]="option.selected"
          (change)="toggleDropdownFilterValue(option, $event)" />
        <label [for]="'checkbox-' + option.value + '-level-' + level">{{ option.label }}</label>
      </div>

      <button 
        *ngIf="option.hasChildren()" 
        type="button" 
        class="expand-button"
        (click)="toggleItemExpansion(option)"
        [attr.aria-expanded]="option.expanded">
        <i [class]="option.expanded ? 'pe-7s-angle-up' : 'pe-7s-angle-down'" 
           style="color: var(--grey-500, #939598); font-size: 32px; font-weight: 500;"></i>
      </button>
    </div>
    
    <div class="dropdown-children" *ngIf="option.hasChildren() && option.expanded">
      <ng-container *ngFor="let child of option.children">
        <ng-container *ngTemplateOutlet="dropdownItemTemplate; context: { $implicit: child, level: level + 1 }"></ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>

<!-- Merchant ID Dialog -->
<app-merchant-id-dialog
  [(isVisible)]="isMerchantIdDialogVisible"
  (merchantIdSubmit)="handleMerchantIdSubmit($event)"
  (closed)="handleMerchantIdDialogClose()">
</app-merchant-id-dialog>
